import React, {
  forwardRef,
  useRef,
  useImperativeHandle,
  useEffect
} from 'react'
import PropTypes from 'prop-types'

const ErrorModal = forwardRef((props, ref) => {
  const modalRef = useRef(null)

  // Expose open() and close() methods to parent
  useImperativeHandle(ref, () => ({
    open: () => $(modalRef.current).modal('show'),
    close: () => $(modalRef.current).modal('hide')
  }))

  useEffect(() => {
    return () => {
      $(modalRef.current).modal('hide')
      $('.modal-backdrop').remove()
      $('body').removeClass('modal-open')
    }
  }, [])

  return (
    <div
      ref={modalRef}
      className="modal fade"
      tabIndex={-1}
      id="payment_error_modal"
      role="dialog">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 className="modal-title">Erreur lors du paiement</h4>
          </div>
          <div className="modal-body">
            <div className="alert alert-danger mb-0" role="alert">
              {props.errors.map(function (error, index) {
                return <p key={index}>{error.message}</p>
              })}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-default"
              data-dismiss="modal">
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
  )
})

ErrorModal.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.object).isRequired
}

ErrorModal.displayName = 'ErrorModal'
export default ErrorModal
